import React from "react";
import "./Footer.css";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer" aria-label="Footer">
      <div className="footer__top">
        <div className="footer__container">
          {/* Left: Brand + description */}
          <div className="footer__brandCol">
            <div className="footer__brand">COMMUNITY IMPACT SOLUTIONS</div>
            <p className="footer__desc">
              We bring together firsthand experience, professional training, and proven leadership 
              to drive meaningful impact in every initiative we support, helping fathers, families, 
              and communities thrive.
            </p>
          </div>

          {/* Middle: Quick Links */}
          <nav className="footer__col" aria-label="Quick links">
            <h3 className="footer__title">Quick Links</h3>
            <ul className="footer__list">
              <li><Link className="footer__link" to="/">Home</Link></li>
              <li><Link className="footer__link" to="/about-us">About</Link></li>
              <li><Link className="footer__link" to="/service">Service</Link></li>
              <li><Link className="footer__link" to="/contact">Contact</Link></li>
            </ul>
          </nav>

          {/* Right: Address, Contact, Hours and Social Icons */}
          <div className="footer__rightCol">
            {/* Address Column */}
            <div className="footer__addressCol">
              <h3 className="footer__title">Visit Us</h3>
              <address className="footer__address">
                Community Impact Solutions LLC<br />
                P.O. box 950<br />
                Tacoma, WA 98401<br />
                United States
              </address>
              
              <div className="footer__contact">
                <p className="footer__contact-item">
                  <span className="footer__contact-label">Phone:</span> +1.2532303558
                </p>
                <p className="footer__contact-item">
                  <span className="footer__contact-label">Email:</span> nelson@communityimpactsolutionsllc.com
                </p>
              </div>

              <div className="footer__hours">
                <h4 className="footer__hoursTitle">Hours</h4>
                <p className="footer__hoursText">Monday to Friday</p>
                <p className="footer__hoursText">9am - 5pm</p>
              </div>

              {/* Social Media Icons */}
              <div className="footer__social">
                <h4 className="footer__socialTitle">Follow Us</h4>
                <div className="footer__socialIcons">
                  <a 
                    href="https://www.facebook.com/search/top?q=community%20impact%20solutions%20llc" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer__socialIcon"
                    aria-label="Facebook"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z"/>
                    </svg>
                  </a>
                  <a 
                    href="https://www.linkedin.com/company/community-impact-solutions-llc-washington" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="footer__socialIcon"
                    aria-label="LinkedIn"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M4.98 3.5c0 1.381-1.11 2.5-2.48 2.5s-2.48-1.119-2.48-2.5c0-1.38 1.11-2.5 2.48-2.5s2.48 1.12 2.48 2.5zm.02 4.5h-5v16h5v-16zm7.982 0h-4.968v16h4.969v-8.399c0-4.67 6.029-5.052 6.029 0v8.399h4.988v-10.131c0-7.88-8.922-7.593-11.018-3.714v-2.155z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="footer__bottom">
        <p className="footer__copy">
          © {new Date().getFullYear()} Community Impact Solutions LLC. All Rights Reserved.{" "}
          <span aria-hidden="true">|</span>{" "}
          <a href="https://connectrader.com/" target="_blank" rel="noopener noreferrer" style={{ color: "inherit", textDecoration: "none" }}>Site By connectrader</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;